import { render, staticRenderFns } from "./CreatedComment.vue?vue&type=template&id=0a8ab388&scoped=true&"
import script from "./CreatedComment.vue?vue&type=script&lang=js&"
export * from "./CreatedComment.vue?vue&type=script&lang=js&"
import style0 from "./CreatedComment.vue?vue&type=style&index=0&id=0a8ab388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ab388",
  null
  
)

export default component.exports